<template>
  <div class="frr-root">
    <div v-for="row in shaped" :key="row.label" class="frr-row" :title="row.tip || null">
      <!-- sr-only twin of the title tooltip so the detail reaches
           keyboard and touch readers too -->
      <span class="frr-label">{{ row.label }}<span v-if="row.tip" class="sr-only">, {{ row.tip }}</span></span>
      <span class="frr-track">
        <span class="frr-bar" :style="{ width: row.pct + '%', background: row.color || color }"></span>
      </span>
      <span class="frr-count">{{ row.value.toLocaleString() }}</span>
    </div>
  </div>
</template>

<script>
// shared ranked value-bar list: label / thin bar / count, the table-chart
// hybrid from the orm analytics redesign. the count is always visible as
// text, so color never gates a value. single-series magnitude by default
// (one hue for every bar -- never a value ramp on nominal categories);
// a row may carry its own color for status-semantic lists.
export default {
  name: 'fi_rank_rows',

  props: {
    // [{ label, value, tip?, color? }]
    rows: { type: Array, required: true },
    color: { type: String, default: '#2b6cb8' },
  },

  computed: {
    shaped() {
      const max = Math.max(1, ...this.rows.map(r => r.value || 0))
      return this.rows.map(r => {
        const v = r.value || 0
        // the 1.5% visibility floor applies only to real values: a zero
        // must render no bar at all, or it reads as a tiny nonzero
        return { ...r, value: v, pct: v ? Math.max(1.5, (v / max) * 100) : 0 }
      })
    },
  },
}
</script>

<style scoped>
.frr-root {
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* the bars are the data; page print stylesheets strip backgrounds */
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.frr-row {
  display: grid;
  grid-template-columns: 150px 1fr 48px;
  align-items: center;
  gap: 10px;
  padding: 4px 6px;
  border-radius: 8px;
}
.frr-row:hover { background: color-mix(in srgb, var(--fi-text-muted, #6b7a8c) 9%, transparent); }
.frr-label {
  font-size: 12.5px;
  color: var(--fi-text, #2c3a49);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.frr-track { position: relative; height: 10px; }
.frr-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-radius: 2px 4px 4px 2px;
}
.frr-count {
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: var(--fi-text-muted, #55636f);
}
@media (max-width: 700px) {
  .frr-row { grid-template-columns: 110px 1fr 44px; }
}
</style>
